import ReviewingController from './reviewing.component';


export default angular
  .module('fizyweb.paycell.student.reviewing', [])
  .component('reviewing', ReviewingController).name;



// WEBPACK FOOTER //
// src/app/components/student/reviewing/reviewing.module.ts